
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import StickyFilterContainer from '@/components/reports-v3/components/pages/StickyFilterContainer.vue';
import ActiveCustomersNumberDisplayer from '@/components/reports-v3/components/codedWidgets/sales/SalesActiveCustomerNumberDisplayer.vue';
import ExistingCustomersNumberDisplayer from '@/components/reports-v3/components/codedWidgets/sales/SalesExistingCustomerNumberDisplayer.vue';
import NewCustomersNumberDisplayer from '@/components/reports-v3/components/codedWidgets/sales/SalesNewCustomerNumberDisplayer.vue';
import NewCustomerTable from '@/components/reports-v3/components/codedWidgets/sales/SalesNewCustomerTable.vue';
import CustomerRetentionTable from '@/components/reports-v3/components/codedWidgets/sales/SalesCustomerNoActivityTable.vue';
import LastSync from '@/components/LastSync.vue';
import userx from '@/store/modules/userx';
import router from '@/router';
import moment from 'moment';
import DateFilter from '@/components/reports-v3/components/filters/DateFilter.vue';
import gdbx from '@/store/modules/gdbx';

@Component({
	components: {
		ActiveCustomersNumberDisplayer,
		ExistingCustomersNumberDisplayer,
		NewCustomersNumberDisplayer,
		NewCustomerTable,
		CustomerRetentionTable,
		StickyFilterContainer,
		DateFilter,
		LastSync,
	},
})
export default class SalesGrowth extends Vue {
	public selectedDay: number = moment().endOf('year').valueOf();

	public mounted() {
		this.track();
	}

	public track() {
		this.$ga.set('userId', userx.user!.uid + '_' + userx.user!.email);
		this.$ga.page(router);
	}

	public get selectedAsOfDate() {
		return moment(this.selectedDay).endOf('year').valueOf();
	}

	public get selectedDateRange(): [number, number] {
		return [
			moment(this.selectedDay).startOf('year').valueOf(),
			moment(this.selectedDay).endOf('year').valueOf(),
		];
	}

	public get selectedAgents() {
		return gdbx.allAgents.map((vt) => vt.value);
	}

	public get selectedStockItems() {
		return gdbx.allStockItems.map((vt) => vt.value);
	}

	public get selectedCustomers() {
		return gdbx.allCustomers.map((vt) => vt.value);
	}

	public onHovering(value: boolean, filterId: string) {
		this.$emit('hovering', value, filterId);
	}
	public onEditing(value: boolean, filterId: string) {
		this.$emit('editing', value, filterId);
	}
}
